import { useEffect, useState } from "react";
import { TailSpin } from "react-loader-spinner";
import Cookies from "js-cookie";
import axios from "axios";
import { API_GET_ACCESS_TYPES } from "../../config/Endpoints";
import SortableTable from "../../components/SortableTable";
import NoRecordsAvailable from "../../components/NoRecordsAvailable";
import { formatDate } from "../../utils/helpers";
import CreateAccessTypeModal from "../AssetLevelManagement/CreateAccessTypeModal";
import Badge from "../../components/Badge";

const CreateAccessType = ({ accessTypeList, setAccessTypeList }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [accessTypes, setAccessTypes] = useState([]);
  const accessToken = Cookies.get("accessToken");

  const fetchAccessTypes = async () => {
    setIsLoading(true);
    try {
      const url = `${API_GET_ACCESS_TYPES}?status=`;
      const res = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });
      const accessTypesData = res?.data?.data?.accessTypes || [];
      setAccessTypes(accessTypesData);
    } catch (error) {
      console.error("Error fetching access types:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchAccessTypes();
  }, []);

  const columns = [
    { key: "accessType", label: "Access Type" },

    { key: "requestedDate", label: "Requested Date" },
    { key: "comment", label: "Description" },
    {
      key: "status",
      label: "Access Status",
      render: (item) => (
        <Badge
          type={
            item.status === "PENDING"
              ? "warning"
              : item.status === "REJECTED"
              ? "danger"
              : "success"
          }
          className="text-capitalize"
        >
          {item.status === "PENDING"
            ? "Pending"
            : item.status === "REJECTED"
            ? "Rejected"
            : "Approved"}
        </Badge>
      ),
    },
  ];

  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    setTableData(
      accessTypes?.map((item) => ({
        accessType: item.name,

        requestedDate: formatDate(item.createdAt),
        comment: item.description || "-",
        status: item.status || "PENDING",
        _original: item,
      })) || []
    );
  }, [accessTypes]);

  return (
    <div className="px-2 py-2">
      {isLoading && (
        <div className="overlay">
          <div className="mt-5">
            <TailSpin
              height="100"
              width="100"
              color="blue"
              ariaLabel="tail-spin-loading"
              visible={true}
            />
          </div>
        </div>
      )}

      {/* Create Access Type Modal */}
      <div
        className="modal fade"
        id="staticBackdropCreateAccessType"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content">
            <CreateAccessTypeModal
              accessTypeList={accessTypes}
              setAccessTypes={setAccessTypes}
            />
          </div>
        </div>
      </div>

      {/* Action Bar */}
      <div className="action-bar" style={{ justifyContent: "flex-end" }}>
        <div className="actions-wrapper">
          <div className="actions">
            <button
              className="export theme-button"
              type="button"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdropCreateAccessType"
            >
              Create
            </button>
          </div>
        </div>
      </div>

      {/* Table */}
      <div className="row">
        <div className="col-md-12">
          {!isLoading && (
            <>
              {tableData && tableData.length > 0 ? (
                <SortableTable columns={columns} data={tableData} />
              ) : (
                <div className="container">
                  <NoRecordsAvailable />
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreateAccessType;
